// extracted by mini-css-extract-plugin
export default {"swatch":"UNhlx0lIrf"};